// Utility functions for managing line item codes
export const parseCode = (code: string) => {
  const match = code.match(/^([A-Z-. ]+)(\d+)$/)
  if (!match) return null

  return {
    prefix: match[1],
    number: parseInt(match[2], 10)
  }
}

export const generateNextCode = (existingCodes: string[]): string => {
  if (existingCodes.length === 0) return 'FN01'

  // Get the last used code
  const lastCode = existingCodes[existingCodes.length - 1]
  const parsed = parseCode(lastCode)

  if (!parsed) return 'FN01'

  // Find the highest number for this prefix
  const samePrefix = existingCodes
    .map((code) => parseCode(code))
    .filter(
      (p): p is NonNullable<typeof p> =>
        p !== null && p.prefix === parsed.prefix
    )

  const highestNumber = Math.max(...samePrefix.map((p) => p.number))

  // Format new number with leading zero
  const nextNumber = (highestNumber + 1).toString().padStart(2, '0')
  return `${parsed.prefix}${nextNumber}`
}
